import { useState, useEffect, useContext, useRef } from "react";
import RegisterChat from "../chat/RegisterChat";

import { ChatContext } from "../../context/ChatContext";
import { getSocket } from "../../services/socket";
import ChatBox from "../chat/ChatBox";
import TopBar from "../chat/TopBar";

import { useAuth } from "../../context/AuthContext"; // Importe o hook
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";


export default function WebsocketClient() {
  // Use o hook personalizado para pegar o usuário
  const { user } = useAuth();

  const [connected, setConnected] = useState(false);
  const [registerChatCard, setRegisterChatCard] = useState(null);
  const [userList, setUserList] = useState([]);
  const [myName, setMyName] = useState("Nome");
  const [chatList, setChatList] = useState([]);

  const { currentUser, setCurrentUser, currentSelectedChat, setCurrentSelectedChat } = useContext(ChatContext);
  const { setIsOpenLogin } = useContext(AppContext);

  const socketRef = useRef(null);
  const navigate = useNavigate();


  useEffect(() => {
    

    return () => {

          // fecha o socket se estiver aberto
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null;
      setConnected(false);
    }

    // fecha o overlay de login
    setIsOpenLogin(false);



    };
  }, []);

  // Inicialização
  useEffect(() => {
    if (user) {
      setCurrentUser(user);
    }
    // Limpa lista inicial se necessário
    setChatList([]);
  }, [user, setCurrentUser]);

  // Sincronização do chat selecionado
  useEffect(() => {
    if (currentSelectedChat && chatList.length > 0) {
      const updatedChat = chatList.find(c => c.chatID === currentSelectedChat.chatID);
      if (updatedChat && updatedChat !== currentSelectedChat) {
        setCurrentSelectedChat(updatedChat);
      }
    }
  }, [chatList, currentSelectedChat, setCurrentSelectedChat]);

  //#region CONNECTIONS ---------------------
  function connect() {
    // Proteção: Não conecta se não houver usuário logado
    if (!user) {
      console.error("Usuário não autenticado.");
      return;
    }

    if (socketRef.current) return;

    const ws = getSocket();
    socketRef.current = ws;

    ws.onopen = () => {
      console.log("Conectado");
      setConnected(true);
      EmitCheckMe();
    };

    ws.onmessage = (event) => {
      On(event.data);
    };

    ws.onclose = () => {
      console.log("Desconectado");
      setConnected(false);
      socketRef.current = null;
    };
  }

  function getCurrentSocket() {
    return socketRef.current;
  }

  function sendMsg(data) {
    EmitMessage(data);
  }

  function On(data) {
    try {
      data = JSON.parse(data);
    } catch {
      return;
    }

    const { nameEvent } = data;

    if (nameEvent) {
      switch (nameEvent) {
        case "checkMe":
          OnCheckMe(data);
          break;
        case "successfullyRegistered":
          OnSuccessfullyRegistered(data);
          break;
        case "updatedUserList":
          OnUpdatedUserList(data.data);
          break;
        case "chatListUpdated":
          OnChatListUpdated(data.data);
          break;
        case "newMessage":
          OnNewMessage(data.data);
          break;
        case "chatOpened":
          OnChatOpened(data.data);
          break;

      }
    }
  }
  //#endregion

  //#region EMITs ------------------------------
  function Emit(nameEvent, data) {
    const socket = getCurrentSocket();
    if (!socket) return;
    socket.send(JSON.stringify({ nameEvent, data }));
  }

  function EmitCheckMe() {
    if (!user) return;
    Emit("checkMe", { uid: user.uid });
  }

  function EmitRegisterMe(data) {
    Emit("registerMe", data);
  }

  function EmitGetusersOnline() {
    Emit("getUsersOnline", "");
  }

  function EmitOpenChat(data) {
    Emit("openChat", data);
  }

  function EmitGetMyChats() {
    Emit("getMyChats", "");
  }

  function EmitMessage(data) {
    Emit("chatMessage", data);
  }
  //#endregion

  //#region FUNCTIONS -------------------------
  function RegisterUser(name, profileUrl) {
    if (!user || !name || !profileUrl) return;

    EmitRegisterMe({
      name: name,
      profileUrl: profileUrl,
      uid: user.uid,
      idToken: user.idToken,
    });
  }

  function handleOpenChat(data) {
    const chat = chatList.find(c => c.uidList.includes(data.otherUid));
    if (chat) {
      setCurrentSelectedChat(chat);
    } else {
      EmitOpenChat(data);
    }
  }

  function LogOut() {
    // encerra a sessão do Firebase
    // signOut(auth);

    // fecha o socket se estiver aberto
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null;
      setConnected(false);
    }

    // fecha o overlay de login
    setIsOpenLogin(false);

    // redireciona para a home
    navigate("/");
  }
  //#endregion

  //#region ONs ------------------------------
  function OnCheckMe(data) {
    const { status, user: serverUser } = data.data;

    if (status === "ok" && serverUser) {
      setCurrentUser(serverUser);
      setMyName(serverUser.name);
      setRegisterChatCard(<></>);
      EmitGetusersOnline();
      EmitGetMyChats();
      return;
    }

    if (status === "error") {
      setRegisterChatCard(<RegisterChat register={RegisterUser} />);
    }
  }

  function OnSuccessfullyRegistered(data) {
    const { status, user: serverUser } = data.data;

    if (status === "ok" && serverUser) {
      setCurrentUser(serverUser);
      setMyName(serverUser.name);
      setRegisterChatCard(<></>);
      EmitGetusersOnline();
      EmitGetMyChats();
    }
  }

  function OnUpdatedUserList(data) {
    setUserList(data.userList);
  }

  function OnChatListUpdated(data) {
    const normalizedChats = (data.chatList || []).map(chat => ({
      chatID: chat.chatID || "",
      createdAt: chat.createdAt || "",
      uidList: chat.uidList || [],
      chatUserList: chat.chatUserList || [],
      chatLineList: chat.chatLineList || [],
    }));
    setChatList(normalizedChats);
  }

  function OnNewMessage(data) {
    const { chatID, chatLine, chatUserList, uidList } = data;

    setChatList(prevChats => {
      const existingChatIndex = prevChats.findIndex(c => c.chatID === chatID);

      if (existingChatIndex >= 0) {
        const newChats = [...prevChats];
        newChats[existingChatIndex] = {
          ...newChats[existingChatIndex],
          chatLineList: [...(newChats[existingChatIndex].chatLineList || []), chatLine]
        };
        return newChats;
      } else {
        const newChat = {
          chatID: chatID,
          createdAt: new Date().toISOString(),
          uidList: uidList,
          chatUserList: chatUserList || [],
          chatLineList: [chatLine]
        };
        return [...prevChats, newChat];
      }
    });
  }

  function OnChatOpened(data) {
    setChatList(prevChats => {
      const exists = prevChats.some(chat => chat.chatID === data.chatID);

      if (exists) {
        return prevChats.map(chat => {
          if (chat.chatID === data.chatID) {
            return {
              ...chat,
              chatLineList: [...(chat.chatLineList || []), data.chatLine]
            };
          }
          return chat;
        });
      } else {
        return [...prevChats, data];
      }
    });
  }

  //#endregion


  //#region RETURN ------------------------
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {!connected ? (
        <button onClick={connect}>Conectar</button>
      ) : (
        <>
          <TopBar
            userList={userList}
            connected={connected}
            myName={myName}
            onLogout={() => { LogOut() }}
            openChat={handleOpenChat}
            currentUser={currentUser}
          />

          {registerChatCard}

          <div style={{ flex: 1, overflow: "hidden" }}>
            <ChatBox chatList={chatList} sendMsg={sendMsg} />
          </div>
        </>
      )}
    </div>
  );
}